import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IUserListResponse } from '../../common/types/userTypes';
import { Status } from '../../common/constants';
import { listUserUrl } from '../../config';
import api from '../../api';
import { getCookie } from "../../common/utils";

const initialState: IUserListResponse = {
  users: [],
  status: Status.IDLE,
  error: null,
  dataFetched: false,
};

export const userList: any = createAsyncThunk('listUsers', async (orgId?: string) => {
  try {
    const organizationId: string = orgId? orgId : getCookie('organizationId');
    const response = await api.get(listUserUrl+`?orgId=${organizationId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
});

const userSlice = createSlice({
  name: 'listUsers',
  initialState,
  reducers: {
    setDataFetched:(state,action)=>{
      state.dataFetched = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(userList.pending, (state) => {
        state.status = Status.PENDING;
      })
      .addCase(userList.fulfilled, (state, action) => {
        state.status = Status.SUCCESS;
        state.users = action.payload;
      })
      .addCase(userList.rejected, (state, action) => {
        state.status = Status.FAILED;
        state.error = action.error.message;
      });
  },
});

type Selector = {
  listUser: ReturnType<typeof userSlice.reducer>;
};

export const selector = (store: Selector) => store['listUser'];

export default userSlice.reducer;

export const { setDataFetched } = userSlice.actions;
